import { TextField } from '@efexteam/components';
import { RoleId, RoleIds } from '@efexteam/permission-manager';
import { Box, MenuItem, Typography } from '@mui/material';
import ROLES_DESCRIPTIONS from '@pages/teamMember/constants/rolesDescriptions';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectProfileData } from '@pages/profile/store/selectors';
import { useMemo } from 'react';
import { IRoleSelector } from './types';
import RoleSelectorStyles from './RoleSelector.style';

const RoleSelector = ({ roleId, setRoleId, selectorLabel }: IRoleSelector) => {
  const { t } = useTranslation();
  const profile = useSelector(selectProfileData);
  const { canAddPromoter } = profile || {};

  const availableRoles = useMemo(
    () =>
      ROLES_DESCRIPTIONS.filter(
        (role) =>
          !(
            (role.value === RoleIds.PROMOTER && !canAddPromoter) ||
            role.value === RoleIds.OWNER
          )
      ),
    [canAddPromoter]
  );

  return (
    <TextField
      select
      fullWidth
      value={roleId}
      label={selectorLabel}
      disabled={roleId === RoleIds.OWNER}
      onChange={(e) => {
        setRoleId(e.target.value as unknown as RoleId);
      }}
      SelectProps={{
        renderValue: (selected) =>
          t(
            ROLES_DESCRIPTIONS.find((option) => option.value === selected)
              ?.label || ''
          ),
        MenuProps: {
          PaperProps: {
            className: RoleSelectorStyles.menuPaperProps,
          },
        },
      }}
    >
      {availableRoles.map((option) => (
        <MenuItem
          className={RoleSelectorStyles.menuItem}
          key={option.value}
          value={option.value}
        >
          <Box sx={{ py: 1 }}>
            <Typography
              variant="body1"
              className={RoleSelectorStyles.menuItemLabel}
            >
              {t(option.label)}
            </Typography>
            <Typography
              variant="caption"
              className={RoleSelectorStyles.menuItemDescription}
            >
              {t(option.description)}
            </Typography>
          </Box>
        </MenuItem>
      ))}
    </TextField>
  );
};

export default RoleSelector;
